/**
 * Try to parse positive numeric value from given value
 * @param {string} value decimal number
 * @returns {number} if a parsing is a success number is returned otherwise NaN value
 */
const parseDecimalNumber = (value) => {
  let result = NaN;
  if( typeof value === 'string' ) {
    const _value = value.replaceAll(' ','').replace(',','.');
    if( new RegExp('^[0-9]+[.][0-9]+$|^[0-9]+$').test(_value) ) {
      result = parseFloat(_value);
    }
  }

  return result;
}

export {
  parseDecimalNumber
}
